import {z} from 'zod';
import _isNil from 'lodash/isNil';

import {MacroItemTypeValue} from 'common/src/modules/macros/macros.types';
import {conditionOutputSchema} from '../../promptToCardAgentV2.schemas';
import {ConditionOperatorKey} from 'common/src/modules/conditions/conditions.types';
import {AIConditionSignal} from '../../promptToCardAgentV2.types';

export function validateStrictOptionalTextValuesForSignal(
  condKey: string,
  availableSignals: AIConditionSignal[] | undefined,
  textValues: string[] | undefined,
): string {
  if (!condKey || !textValues?.length) {
    return '';
  }

  const activeSignal = availableSignals?.find((s) => s.value === condKey);

  if (!activeSignal?.strictOptionalValues) {
    return '';
  }

  const validValues = activeSignal.optionalValues.map((o) => o.value);
  const invalidValues = textValues.filter((v) => !validValues.includes(v));

  if (invalidValues.length) {
    return `Invalid values: ${invalidValues.join(', ')}. This signal has strictOptionalValues, so textValues must use the 'value' field from optionalValues. Valid values are: ${validValues.join(', ')}`;
  }

  return '';
}

export default function validateConditionOutput(
  conditionOutput: z.input<typeof conditionOutputSchema>,
  condKeyType: MacroItemTypeValue,
  condOperator: ConditionOperatorKey,
) {
  let error = '';

  if (
    (condKeyType === MacroItemTypeValue.TextList || condKeyType === MacroItemTypeValue.Text) &&
    !conditionOutput.textValues
  ) {
    error = 'Text values are required for text condition key type';
  }

  if (condKeyType === MacroItemTypeValue.Numeric) {
    if (condOperator === ConditionOperatorKey.Between) {
      if (!conditionOutput.numbersRange) {
        error = 'Numeric range is required for numeric range condition key type';
      }
    } else {
      if (!conditionOutput.numericValues) {
        error = 'Numeric values are required for numeric condition key type';
      }
    }
  }

  if (condKeyType === MacroItemTypeValue.Condition && _isNil(conditionOutput.booleanValue)) {
    error = 'Boolean value is required for condition condition key type';
  }

  if (
    [MacroItemTypeValue.Date, MacroItemTypeValue.DateList].includes(
      condKeyType as MacroItemTypeValue,
    ) &&
    !conditionOutput.dateValues
  ) {
    error = 'Date values are required for date condition key type';
  }

  if (
    [MacroItemTypeValue.DateRange].includes(condKeyType as MacroItemTypeValue) &&
    !conditionOutput.datesRange
  ) {
    error = 'Date range is required for date range condition key type';
  }

  return error;
}
